import { Controller } from '@hotwired/stimulus'

// Bridges a trigger element to a remote <turbo-frame> that lives elsewhere in
// the DOM, assigning the frame's `src` the first time the action fires.
// Replaces the `toggle: { event: :click }` pattern from `render_async`.
//
// Action params:
//   src   (String) — URL assigned to the frame on the first load.
//   frame (String) — id of the <turbo-frame> to load.
//
// Usage (on the trigger element):
//   <a data-controller="lazy-frame"
//      data-action="click->lazy-frame#load"
//      data-lazy-frame-src-param="<%= path %>"
//      data-lazy-frame-frame-param="my-frame">Show</a>
//   <turbo-frame id="my-frame"></turbo-frame>
//
// Mirrors `once: true`: after the frame's `src` is set the first time, further
// triggers are no-ops (the frame is not reloaded).
export default class extends Controller {
  load({ params }) {
    const frame = document.getElementById(params.frame)
    if (frame && !frame.getAttribute('src')) {
      frame.setAttribute('src', params.src)
    }
  }
}
